import React from 'react'

const HomeMenu: React.FC = () => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_103_17169)"
      fillOpacity="0.1"
    />
    <path
      d="M23.1353 13.9834L16.2603 9.24729C16.1039 9.13974 15.8973 9.13974 15.7403 9.24729L8.86527 13.9834C8.7406 14.069 8.66666 14.2101 8.66666 14.3611V23.2222C8.66666 23.5595 8.94043 23.8333 9.27777 23.8333H14.1667V18.9444C14.1667 18.6071 14.4404 18.3333 14.7778 18.3333H17.2222C17.5595 18.3333 17.8333 18.6071 17.8333 18.9444V23.8333H22.7222C23.0595 23.8333 23.3333 23.5595 23.3333 23.2222V14.3611C23.3333 14.2101 23.2594 14.069 23.1353 13.9834Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_103_17169"
        x1="15.7922"
        y1="0.5"
        x2="15.7922"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default HomeMenu
